module.exports = __webpack_public_path__ + "static/media/dingzhi.c1eb44ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/dingzhi.svg
// module id = 34
// module chunks = 6